import React from "react";
import { RevealLine, FadeUp } from "./Reveal";

const CHAPTERS = [
  {
    no: "01",
    title: "Movement is memory",
    body: "Every journey leaves a residue. We design for the seconds between platforms — the blur, the reflection, the echo that lingers after the doors close.",
  },
  {
    no: "02",
    title: "Built for the dark",
    body: "Technical fabrics, matte hardware, tonal graphics. Nothing shouts. Everything is engineered to be seen only by those paying attention.",
  },
  {
    no: "03",
    title: "Leave an echo",
    body: "Ghostline is not about presence. It is about the trace you leave behind — the silhouette remembered long after you've gone.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-28 md:py-40 bg-black px-6 md:px-12"
    >
      <div className="max-w-5xl">
        <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-steel-light mb-10">
          04 — Manifesto
        </p>
        <h2 className="font-display text-[13vw] md:text-[8vw] font-extrabold tracking-tighter leading-[0.85] text-white mb-24">
          <RevealLine>Leave an echo</RevealLine>
          <RevealLine delay={0.12} className="chrome-text">
            worth remembering.
          </RevealLine>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-14 border-t border-white/10 pt-16">
        {CHAPTERS.map((ch, i) => (
          <FadeUp key={ch.no} delay={i * 0.12} className="max-w-sm">
            <div className="flex items-start gap-4 mb-5">
              <span className="font-mono-tech text-xs text-steel-light pt-1">
                / {ch.no}
              </span>
              <h3 className="font-display text-2xl font-bold tracking-tight text-white">
                {ch.title}
              </h3>
            </div>
            <p className="text-steel-light leading-relaxed">{ch.body}</p>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}
